import { useCallback } from "react"
import { useSetState } from "ahooks"
import { createModel } from "hox"
import type { SiteSelectionReport, SiteVO } from "@/api"

type UseSiteSelectionReportState = {
  siteSelectionReport: SiteSelectionReport
  siteSelection?: SiteVO
}

function useSiteSelectionReport() {
  const [state, setState] = useSetState<UseSiteSelectionReportState>({
    siteSelectionReport: null as unknown as SiteSelectionReport,
  })

  const setSiteSelection = useCallback(
    (site: SiteVO) => {
      setState({ siteSelection: site })
    },
    [setState],
  )

  const setSiteSelectionReport = useCallback(
    (info) => {
      setState({ siteSelectionReport: info })
    },
    [setState],
  )

  return {
    ...state,
    setSiteSelection,
    setSiteSelectionReport,
  }
}

export default createModel(useSiteSelectionReport)
